var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15646 13.9953C9.16733 14.0062 9.50048 14.0897 9.89674 14.1808C10.293 14.2718 10.6216 14.3324 10.6268 14.3155C10.6321 14.2986 10.6731 14.0235 10.7179 13.7043C10.808 13.0632 11.0261 12.3147 11.2591 11.8466C11.9854 10.3876 13.2886 9.42162 14.8692 9.17054L15.2717 9.10659V8.46211V7.81758L14.9069 7.75637C12.5168 7.3554 10.9586 5.56834 10.6672 2.894C10.6481 2.71937 10.6254 2.57654 10.6166 2.57654C10.536 2.57654 9.20039 2.89842 9.17513 2.92392C9.15686 2.94236 9.17045 3.10607 9.20537 3.28766C9.59186 5.29847 10.6985 6.93471 12.1346 7.61887L12.479 7.78298L5.39531 7.79584L0.916016 7.80399V9.10833L5.40684 9.1165L12.4739 9.1294L12.039 9.34974C10.9107 9.92134 10.0175 11.0426 9.49148 12.5476C9.34158 12.9763 9.1154 13.9538 9.15646 13.9953Z",
    fill: "#299D6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2cc47efb09400d73149336facdd705c0.svg";
export { ForwardRef as ReactComponent };